export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUt";
export const USERNAME = "USERNAME";
export const PASSWORD = "PASSWORD";
export const AUTHENTICATED = "AUTHENTICATED";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
